import Main from "../components/layout/Main";
import Projects from "../containers/CohortBuilder/Projects/Projects";
import React from "react";
import styles from "../containers/Storyboard/styles.module.scss";
import PathwayViewerIcon from "./homepage/icons/svg/PWV.svg";
import ParentRouteRedirect from "../components/ParentRouteRedirect";


const PageHeader = () => {
    return (
        <div className={styles.pathwayHeader}>
            <ParentRouteRedirect route={'/pathway-viewer'}>
            <div className={styles.title_container}>
                <img className={styles.logo} src={PathwayViewerIcon} alt="pathway viewer logo" />
                <h2 className={styles.title}>Pathway Viewer</h2>
            </div>
            </ParentRouteRedirect>
        </div>
    );
};

export const PathwayViewerStudiesPage = () => {
    return <Main title="Pathway Viewer">
        <PageHeader />
        <Projects/>
    </Main>

}
